import commonSetting from '@intelligence/components/DownloadCommon/DownloadPage/configs/commonSetting';
import { metricTitleMap } from '@intelligence/components/DownloadCommon/DownloadPage/common/baseConfig';
import { getMobileDetailDownloadTitle } from '@intelligence/components/DownloadCommon/DownloadPage/common/baseSetting';
import {
  pipe,
  granularityObject,
  getFileName,
  mergeData,
} from '@intelligence/components/DownloadCommon/DownloadPage/utils';
import {
  setItem,
  setMetricTitle,
  setPercentForPCConsole,
  setTitleByDateMethod,
  setTitleByMainGenreShow,
  setTitleByRegionMethod,
} from '@intelligence/components/DownloadCommon/DownloadPage/common/titleSettingAtom';

// Metrics集合key对应标题
const newMetricMap = {
  ...metricTitleMap,
};

// 下载选项指标转换成接口指标参数
const getDownloadParamsMetrics = (downloadMetrics: string[]) => {
  const metricObj = {
    rv: 'revenue',
    dl: 'download',
    game_count: 'game_count',
  } as any;
  return downloadMetrics?.map((item) => metricObj[item]);
};

// 获取下载表头
const getSheetNames = (params: Record<string, any> = {}) => {
  const paramsValue = {
    ...params,
    download_metrics: getDownloadParamsMetrics(params?.download_metrics),
  } as any;

  // 获取下载表格，Basic Info 表头配置
  const pipeFront = pipe(
    setTitleByDateMethod(paramsValue.downlaod_date_method),
    setTitleByRegionMethod(paramsValue.region_method, true),
    setTitleByMainGenreShow(paramsValue.genre_method),
  );

  // 获取下载表格，指标表头配置
  const metricList = mergeData(paramsValue, {}, 'download_metrics');
  const pipeInLoop = pipe(
    setItem,
    setMetricTitle(newMetricMap, paramsValue.date_type, 'isObject'),
    setPercentForPCConsole(paramsValue.ratio_show),
  );

  // 下载表格表头标题排序
  const excelTitleList = getMobileDetailDownloadTitle(pipeFront, metricList, pipeInLoop);
  const sheetNames = 'MarketProfile';
  return {
    sheetName: [sheetNames],
    [sheetNames]: excelTitleList,
  };
};

// 获取下载个性化参数
const getDownloadApiParams = (params: any) => {
  const {
    region_method,
    genre_method,
    downlaod_date_method,
    regions,
    download_metrics = [],
    fetchParams = {},
  } = params;
  return {
    ...fetchParams,
    source_metrics: {
      sensortower: getDownloadParamsMetrics(download_metrics),
    },
    metrics: getDownloadParamsMetrics(download_metrics),
    regions,
    // b_group_by_platform: true,
    b_group_by_genre: genre_method !== 'aggregated',
    b_group_by_market: region_method === 'market',
    b_group_by_region: region_method === 'region',
    b_group_by_date: downlaod_date_method !== 'aggregated',
    b_growth_ratio: params.ratio_show === 1 || params.ratio_show === '1',
  };
};

// 下载个性化接口参数与表格配置
export default (params: Record<string, any>) => ({
  ...commonSetting,
  isUsingNewMethod: false,
  $$fileName: getFileName(params),
  downloadFetchApi: '/api/v1/intelligence_pc/mobileIeggGenreMetrics',
  dataKey: undefined,
  regionOptions: params?.regionOptions,
  byDate: params?.downlaod_date_method !== 'aggregated',
  granularity: granularityObject[params?.granularity],
  downloadApiParams: getDownloadApiParams(params),
  fetchOnlyOnce: false,
  ...getSheetNames(params),
});
